import { render, staticRenderFns } from "./asset-type.vue?vue&type=template&id=4db8db90&"
import script from "./asset-type.vue?vue&type=script&lang=js&"
export * from "./asset-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports